export default __webpack_public_path__ + "static/media/apple-black-logo.76a36c52.png";